import RatingFeedBackQA from './RatingFeedBackQA';

export default RatingFeedBackQA;
